import React from 'react';

const ScrollingRibbon = () => {
  const phrases = [
    'AI Receptionists',
    '24/7 Lead Capture',
    'Instant Patient Responses',
    'Automated Follow-Ups',
    'More Bookings',
    'No Missed Calls',
    'WhatsApp Integration',
    'Smart Booking Systems'
  ];

  // Duplicate phrases for seamless loop
  const allPhrases = [...phrases, ...phrases];

  return (
    <div className="scrolling-ribbon-container">
      <div className="scrolling-ribbon-track">
        {allPhrases.map((phrase, index) => (
          <React.Fragment key={index}>
            <span className="ribbon-text">{phrase}</span>
            <span className="ribbon-separator">•</span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ScrollingRibbon;
